import React from "react";
import { PatientRequestDetailParent } from "../components/patient-requests/PatientRequestDetail";

const PatientRequestDetail = () => {
  return <PatientRequestDetailParent />;
};

export default PatientRequestDetail;
